import { UserProfile } from '../../entities';
import { IUserProfileRepository } from '../../persistence';

export class UserAnalyticsManager {
    constructor(private userProfileRepository: IUserProfileRepository) {
    }

    public allUsersCsv = async (): Promise<string> => {
        const allUsers = await this.userProfileRepository.getAll();
        const usersMappedAsCsv = this.mapAllUsersToCsv(allUsers);
        return usersMappedAsCsv;
    }

    private mapAllUsersToCsv = (allUsers: UserProfile[]) => {
        const headerRow = `userId,Fullname,Nickname,Email,Date Of Signup,` +
            `Phone Number,Gender,Date Of Birth,Height,Weight,MyZone Belt #,` +
            `Address Line 1,Address Line 2,Plan Id,Plan Status,Plan Cancels at end of term,coupon,` +
            `enrolledFaceId`;
        const rows = [
            headerRow,
        ];
        const allUserRows = allUsers.map((userProfile: UserProfile) => {
            return `${userProfile.uid},${userProfile.fullname},` +
            `${userProfile.nickname},${userProfile.email},` +
            `${this.clean(this.isoFormatDateSafely(userProfile.userSignupDate))},` +
            `${userProfile.mobileNumber},${userProfile.gender},${userProfile.dateOfBirth},${userProfile.height},` +
            `${userProfile.weight},${userProfile.heartRateMonitorIdentifier},` +
            `${this.clean(userProfile.addressLine1)},${this.clean(userProfile.addressLine2)},` +
            `${userProfile.currentPlanId},${userProfile.currentPlanStatus},` +
            `${userProfile.currentPlanCancelAtEndOfTerm},${userProfile.coupon},` +
            `${userProfile.enrolledFaceId ? userProfile.enrolledFaceId : ''}`;
        });
        const joinedRows = rows.concat(allUserRows).join('\r\n');
        return joinedRows.replace(/undefined/g, '');
    }

    private isoFormatDateSafely(date: string): string {
       if (date == null) {
           return '';
       }
       try {
            return new Date(date).toISOString();
       } catch (error) {
           return '';
       }
    }

    private clean(field: string) {
        return field ? field.replace(/,/g, '') : '';
    }
}
